import { render } from "./payorder.vue?vue&type=template&id=0cb03c89&scoped=true"
import script from "./payorder.vue?vue&type=script&lang=js"
export * from "./payorder.vue?vue&type=script&lang=js"

import "./payorder.vue?vue&type=style&index=0&id=0cb03c89&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0cb03c89"

export default script